/* global WL_SERVICE */

import React from 'react';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import { prop } from 'ramda';
import useWhitelabel from '@goeuro/app/client/b2b-components/src/hooks/use-whitelabel';

import { Container } from 'components/shared/container/Container.styled';
import { translate } from 'shared/utils/translate';
import { HeroProps } from './Hero.props';
import * as Styled from './Hero.styled';

const Hero = ({
  title,
  titleValues,
  subHeading,
  className,
  intl,
}: WrappedComponentProps & HeroProps) => {
  const { wlData } = useWhitelabel();

  return (
    <Styled.Holder
      path={`${WL_SERVICE}/hero`}
      bgColor={prop('heroBgColor', wlData)}
      className={className}
    >
      <Styled.ImageMask />
      <Styled.Content>
        <Container>
          <Styled.HeadlineWrapper>
            {subHeading && (
              <Styled.SubHeading>
                {translate({ intl, id: subHeading })}
              </Styled.SubHeading>
            )}
            <Styled.H1>
              {translate({ intl, id: title, values: titleValues })}
            </Styled.H1>
          </Styled.HeadlineWrapper>
        </Container>
      </Styled.Content>
    </Styled.Holder>
  );
};

export default injectIntl(Hero);
